// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';
import MagnifyIcon from '@material-ui/icons/Search';

import AnalyticsBase from '../AnalyticsBase';
import AnalyticsFilterBar from '../AnalyticsFilterBar';
import EmptyState from '../../common/EmptyState';
import BreadcrumbNav from '../../nav/BreadcrumbNav';

import { initializeAnalytics } from '../../../state/reducer/analytics/actionCreators/initializeAnalytics';
import * as LibraryState from '../../../state/reducer/library/library';

import Console from '../../../lib/debug';
import * as AnalyticsState from '../../../state/reducer/analytics/analytics';
import * as AppState from '../../../state/reducer/app/appState';

type Props = {
    dispatch: any => void
};

const PAGE_KEY = 'working-max-history';

class WorkingMaxHistoryView extends Component<Props> {
    constructor(props: Props) {
        super(props);
        LibraryState.fetchAthletes();
        LibraryState.loadExercises();
    }

    componentDidUpdate(prevProps: {}, prevState: {}) {
        this.loadAnalytics();
    }

    loadAnalytics() {
        const dataParams = this.getDataParams();
        if (dataParams.user_ids.length === 0) {
            AppState.stopLoadingAnalytics();
            return;
        }
        if (!dataParams.exercise_id) {
            AppState.stopLoadingAnalytics();
            return;
        }

        this.props.dispatch(initializeAnalytics(PAGE_KEY, dataParams));
    }

    getAthleteId = () => {
        const params = this.getDataParams();
        if (params.user_ids) {
            return parseInt(params.user_ids, 10);
        }
        return undefined;
    };

    getExerciseId = () => {
        const params = this.getDataParams();
        if (params.exercise_id) {
            return parseInt(params.exercise_id, 10);
        }
        return undefined;
    };

    onSelectAthlete = (e: Event, { suggestion }: any) => {
        const { id } = suggestion;
        this.setSearchParams({
            user_id: id
        });
    };

    onSelectExercise = (e: Event, { suggestion }: any) => {
        const { id } = suggestion;
        this.setSearchParams({
            exercise_id: id
        });
    };

    handleUseMetricChange = (useMetric: boolean) => {
        this.setSearchParams({
            use_metric: useMetric ? 1 : 0
        });
    };

    getInitialState = () => {
        const athleteId = this.getAthleteId();
        const exerciseId = this.getExerciseId();

        if (athleteId && exerciseId) {
            return null;
        }

        return (
            <div style={{ paddingTop: 60 }}>
                <EmptyState
                    text="Select Athlete and Exercise to Run Lift History"
                    icon={<MagnifyIcon style={{ fontSize: 81 }} />}
                />
            </div>
        );
    };

    setSearchParams = (params: {}) => {
        const existingParams = AnalyticsState.getSearchParams();
        AnalyticsState.updateSearchParams({
            ...existingParams,
            ...params
        });
    };

    getDataParams = () => {
        const searchParams = AnalyticsState.getSearchParams();

        let userIds = searchParams.user_id;
        let userIdArray = [];
        if (userIds) {
            userIdArray.push(userIds);
        }

        const exercise_id = searchParams.exercise_id;
        let useMetric = parseInt(searchParams.use_metric, 10) === 1;
        if (searchParams.use_metric === undefined) {
            useMetric = this.props && this.props.useMetric;
        }

        return {
            user_ids: userIdArray,
            exercise_id,
            use_metric: useMetric
        };
    };

    getPageTitle = () => {
        let title =
            this.props.metaTree &&
            this.props.metaTree.instances &&
            this.props.metaTree.instances[PAGE_KEY] &&
            this.props.metaTree.instances[PAGE_KEY].title;
        if (title) {
            return title;
        }
        return '';
    };

    render() {
        Console.render('WorkingMaxHistoryView');
        const initialState = this.getInitialState();

        const crumbs = [
            {
                displayString: 'Analytics',
                link: `/analytics`,
                editable: false
            },
            {
                displayString: this.getPageTitle(),
                link: null,
                editable: false
            }
        ];

        const dataParams = this.getDataParams();

        return (
            <div className="has-filter-bar">
                <BreadcrumbNav crumbs={crumbs} />
                <AnalyticsFilterBar
                    athleteSelector={{
                        selectedId: this.getAthleteId(),
                        onSelect: this.onSelectAthlete,
                        isFocused: false
                    }}
                    exerciseSelector={{
                        selectedId: this.getExerciseId(),
                        onSelect: this.onSelectExercise,
                        isFocused: false
                    }}
                    useMetricSelector={{
                        useMetric: dataParams.use_metric,
                        onChange: this.handleUseMetricChange
                    }}
                />
                <AnalyticsBase />
                {initialState}
            </div>
        );
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        ...ownProps,
        athletesTree: state.library.athletesTree,
        exerciseRef: state.library.exerciseRef,
        metaTree: state.analytics.metaTree,
        useMetric: state.app.loggedInUser.use_metric
    };
};

export default connect(mapStateToProps)(WorkingMaxHistoryView);
